import React from 'react'
import clsx from 'clsx'
import { format } from 'date-fns'
import { useTheme } from '@mui/material'

import OverflowText from '../../../atoms/OverflowText'

import { useBreakpoint } from '../../../../providers/BreakpointProvider'
import useStyles from '../UserJoinedAlert/styles'

const UserPartAlert = ({ sender, name, date }) => {
  const theme = useTheme()

  const { isSmall } = useBreakpoint()

  const classes = useStyles()

  const formattedDate = React.useMemo(
    () => format(new Date(date), 'MMM d, h:mm aaa'),
    [date]
  )

  const message = React.useMemo(() => {
    if (name && name !== 'own') {
      if (name === sender) {
        return (
          <OverflowText>
            <span>
              <span style={{ fontWeight: theme.bold.bold }}>{sender}</span> left
              {formattedDate}
            </span>
          </OverflowText>
        )
      }

      return (
        <OverflowText>
          <span>
            <span style={{ fontWeight: theme.bold.bold }}>{sender}</span> was
            removed by{' '}
            <span style={{ fontWeight: theme.bold.bold }}>{name}</span>{' '}
            {formattedDate}
          </span>
        </OverflowText>
      )
    }

    return `${sender} has left the conversation`
  }, [sender, name, formattedDate, theme])

  const mobileMessage = React.useMemo(() => {
    if (name && name !== 'own') {
      if (name === sender) {
        return (
          <OverflowText>
            <label className={clsx(classes.mobileHeader, classes.truncate)}>
              <span style={{ fontWeight: theme.bold.bold }}>{sender}</span> left
            </label>
            <label className={classes.mobileHeaderDate}>{formattedDate}</label>
          </OverflowText>
        )
      }

      return (
        <OverflowText>
          <label className={clsx(classes.mobileHeader, classes.truncate)}>
            <span style={{ fontWeight: theme.bold.bold }}>{sender}</span> was
            removed by{' '}
            <span style={{ fontWeight: theme.bold.bold }}>{name}</span>
          </label>
          <label className={classes.mobileHeaderDate}>{formattedDate}</label>
        </OverflowText>
      )
    }

    return `${sender} has left the conversation`
  }, [sender, name, formattedDate, classes, theme])

  return <div className={classes.root}>{isSmall ? mobileMessage : message}</div>
}

export default UserPartAlert
